import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { FadeInAnimation } from '../shared/fade-in.animation';

@Component({
  selector: 'app-rename-dialog',
  templateUrl: './rename-dialog.component.html',
  styleUrls: ['./rename-dialog.component.scss'],
  animations: [FadeInAnimation]
})
export class RenameDialogComponent implements OnInit {

  name: string = "";

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() { 
    this.name = this.data.templateName;
  }
  
}


// WEBPACK FOOTER //
// ./src/app/transfers/rename-dialog.component.ts